import { showHttpError } from '@calendly/alert'
import { FormError } from '@calendly/form'

export const setFormErrors = (errorData, fieldKeyMap = {}) => {
  switch (errorData.type) {
    case 'validation': {
      const error = new FormError()

      error.payload = Object.fromEntries(
        Object.entries(errorData.payload).map(([key, value]) => {
          const newKey = fieldKeyMap[key] || key

          return [newKey, value]
        })
      )

      throw error
    }
    default:
      return showHttpError(errorData)
  }
}
